// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
table {
    color: black;
    
}
.contable {
    /* border-color: black;
    border-width: 0.3vw;
    border-style: solid; */
    display: flex;
    align-items: start;
    height: 90vh;
    width: 100%;
    z-index: -2;
}
.blank{
    border-color: black;
    border-style: solid;
    border-width: 1vw;
    width: 30%;
    height: 110vh;
}
th,
td,tr {
    /* border: 1px solid black; */
    padding: 8px;
}

.maintable {
    /* margin-left: 25vw; */
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    border: 1px solid black;
    height: 90vh;
    overflow-y: scroll;
    margin-bottom: 1vw;
}

.maintable table thead {
    position: sticky;
    top: 0;
    /* background-color: rgb(0, 26, 102);  */
    background-color: #020131;
    color: white;
    z-index: 2;
  }
th::after,th::before{
  content: "";
  position: absolute;
  left:0;
  width: 100%;
  /* top: -0.25vw; */
}
th::before{
  top:-0vw;
  border-top: 1px solid rgb(0, 0, 0);
}
th::after{
  bottom:-0.2px;
  border-bottom: 0.01px solid black;

}

.mth th.sticky {
  position: sticky;
  top: 0;
  background-color: #f2f2f2;
  border: 1px solid #dddddd;
  z-index: 1;
}

.filter-table {
    /* position: -webkit-sticky; */
    margin-left: 1vw;
    margin-top: 5vw;
    margin-right: 1vw;
    /* margin-bottom: 1VW; */
    position: sticky;
    border: 1px solid black;
    top: 0;
    /* height: 14vw; */
    z-index: 6;
    height: 55vh;
    width: 20vw;
    background-color: white;
    /* box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.2); */
    box-shadow: 0 2px 4px  rgb(0, 26, 102);
}
.filter-text{
  /* background-color:  rgb(0, 26, 102); */
  background-color: #020131;
  color: rgb(255, 255, 255);
  /* padding: 1vw; */
}

  @media (max-width: 760px) {
    .filter-options {
      width: 100%;
      left: 0; 
    }
    .contable {
      display: block;
      
      height: 155vh;
  }
  .filter-table {
    height: 64vh !important;
    width: 98vw;
    padding: 4vw;
    margin-bottom: 2vw;
  }
  }  
  @media (max-width: 1222px) {
    .filter-table {
      height: 70vh;
      min-width: 20vw;
      /* width: 100%; */
    }

  }


`, "",{"version":3,"sources":["webpack://./src/components/table.css"],"names":[],"mappings":";AACA;IACI,YAAY;;AAEhB;AACA;IACI;;0BAEsB;IACtB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,aAAa;AACjB;AACA;;IAEI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,wCAAwC;IACxC,yBAAyB;IACzB,YAAY;IACZ,UAAU;EACZ;AACF;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,iCAAiC;;AAEnC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,MAAM;IACN,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,qDAAqD;IACrD,sCAAsC;AAC1C;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;EAEE;IACE;MACE,WAAW;MACX,OAAO;IACT;IACA;MACE,cAAc;;MAEd,aAAa;EACjB;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;EACA;IACE;MACE,YAAY;MACZ,eAAe;MACf,iBAAiB;IACnB;;EAEF","sourcesContent":["\r\ntable {\r\n    color: black;\r\n    \r\n}\r\n.contable {\r\n    /* border-color: black;\r\n    border-width: 0.3vw;\r\n    border-style: solid; */\r\n    display: flex;\r\n    align-items: start;\r\n    height: 90vh;\r\n    width: 100%;\r\n    z-index: -2;\r\n}\r\n.blank{\r\n    border-color: black;\r\n    border-style: solid;\r\n    border-width: 1vw;\r\n    width: 30%;\r\n    height: 110vh;\r\n}\r\nth,\r\ntd,tr {\r\n    /* border: 1px solid black; */\r\n    padding: 8px;\r\n}\r\n\r\n.maintable {\r\n    /* margin-left: 25vw; */\r\n    border-collapse: collapse;\r\n    table-layout: fixed;\r\n    width: 100%;\r\n    border: 1px solid black;\r\n    height: 90vh;\r\n    overflow-y: scroll;\r\n    margin-bottom: 1vw;\r\n}\r\n\r\n.maintable table thead {\r\n    position: sticky;\r\n    top: 0;\r\n    /* background-color: rgb(0, 26, 102);  */\r\n    background-color: #020131;\r\n    color: white;\r\n    z-index: 2;\r\n  }\r\nth::after,th::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  left:0;\r\n  width: 100%;\r\n  /* top: -0.25vw; */\r\n}\r\nth::before{\r\n  top:-0vw;\r\n  border-top: 1px solid rgb(0, 0, 0);\r\n}\r\nth::after{\r\n  bottom:-0.2px;\r\n  border-bottom: 0.01px solid black;\r\n\r\n}\r\n\r\n.mth th.sticky {\r\n  position: sticky;\r\n  top: 0;\r\n  background-color: #f2f2f2;\r\n  border: 1px solid #dddddd;\r\n  z-index: 1;\r\n}\r\n\r\n.filter-table {\r\n    /* position: -webkit-sticky; */\r\n    margin-left: 1vw;\r\n    margin-top: 5vw;\r\n    margin-right: 1vw;\r\n    /* margin-bottom: 1VW; */\r\n    position: sticky;\r\n    border: 1px solid black;\r\n    top: 0;\r\n    /* height: 14vw; */\r\n    z-index: 6;\r\n    height: 55vh;\r\n    width: 20vw;\r\n    background-color: white;\r\n    /* box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.2); */\r\n    box-shadow: 0 2px 4px  rgb(0, 26, 102);\r\n}\r\n.filter-text{\r\n  /* background-color:  rgb(0, 26, 102); */\r\n  background-color: #020131;\r\n  color: rgb(255, 255, 255);\r\n  /* padding: 1vw; */\r\n}\r\n\r\n  @media (max-width: 760px) {\r\n    .filter-options {\r\n      width: 100%;\r\n      left: 0; \r\n    }\r\n    .contable {\r\n      display: block;\r\n      \r\n      height: 155vh;\r\n  }\r\n  .filter-table {\r\n    height: 64vh !important;\r\n    width: 98vw;\r\n    padding: 4vw;\r\n    margin-bottom: 2vw;\r\n  }\r\n  }  \r\n  @media (max-width: 1222px) {\r\n    .filter-table {\r\n      height: 70vh;\r\n      min-width: 20vw;\r\n      /* width: 100%; */\r\n    }\r\n\r\n  }\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
